module.exports = __webpack_public_path__ + "img/reglamentacion.b3790dcc.png";